import {
  curriculumTypeSchema,
  lessonCountPerMonthSchema,
  lessonMonthSchema,
  lessonTimeSchema,
  paymentTypeSchema,
  promotionTypeSchema,
  ticketLangTypeSchema,
} from '@server/presentation'
import { z } from 'zod'

import { baseCouponSchema } from './coupon.schema'

// Coupon -1 is a product type marker, not the N pass total lesson count.
const couponLessonTypeSchema = z.union([z.literal(-1), z.literal(4), lessonCountPerMonthSchema])
const couponLessonMonthSchema = z.union([z.literal(1), lessonMonthSchema, z.number().int().min(1).max(12)])

export const getRawCouponDetailResponseSchema = z.object({
  coupon_id: z.string(),
  title: baseCouponSchema._def.shape().title,
  discount_type: baseCouponSchema._def.shape().discountType,
  display_status: baseCouponSchema._def.shape().displayStatus,
  discount_amount: baseCouponSchema._def.shape().discountAmount,
  discount_amount_max: baseCouponSchema._def.shape().discountAmountMax,
  discount_application_type: z.enum(['RECURRING', 'LIMITED']).optional().default('RECURRING'),
  discounted_payment_count: z.number().int().positive().optional().default(1),
  utc_use_start: baseCouponSchema._def.shape().utcUseStart,
  utc_use_end: baseCouponSchema._def.shape().utcUseEnd,
  utc_created_at: baseCouponSchema._def.shape().utcCreatedAt,
  description: baseCouponSchema._def.shape().description,
  payment_types: z.array(paymentTypeSchema),

  // baseCouponSchema에 없는 필드
  utc_display_used_at: z.string().nullable(),
  apply_targets: z.array(
    z.object({
      lang_type: ticketLangTypeSchema,
      curriculum_type: curriculumTypeSchema,
      lesson_count_per_month: couponLessonTypeSchema,
      lesson_time: lessonTimeSchema,
      lesson_month: couponLessonMonthSchema,
      payment_type: paymentTypeSchema,
      promotion_type: promotionTypeSchema.nullable(),
    }),
  ),
})

export type GetRawCouponDetailResponse = z.infer<typeof getRawCouponDetailResponseSchema>

export const getCouponDetailResponseSchema = baseCouponSchema.omit({ paymentTypes: true }).extend({
  paymentTypes: getRawCouponDetailResponseSchema._def.shape().payment_types,
  utcDisplayUsedAt: getRawCouponDetailResponseSchema._def.shape().utc_display_used_at,
  applyTargets: z.array(
    z.object({
      langType: ticketLangTypeSchema,
      curriculumType: curriculumTypeSchema,
      lessonCountPerMonth: couponLessonTypeSchema,
      lessonTime: lessonTimeSchema,
      lessonMonth: couponLessonMonthSchema,
      paymentType: paymentTypeSchema,
      promotionType: promotionTypeSchema.nullable(),
    }),
  ),
})

export type GetCouponDetailResponse = z.infer<typeof getCouponDetailResponseSchema>
